/** @format */

export const codeBookCodeModelModule = 'sis-components.model.codebookCode';

(function () {
    codebookCodeJSDataModel.$inject = ['DS', 'CodeEndpoint'];
    angular
        .module(codeBookCodeModelModule, ['js-data'])
        .factory('codebookCodeJsDataModel', codebookCodeJSDataModel)
        .constant('CodeEndpoint', {
            DEFAULT: '/kori/api/codebook-codes',
        });
    function codebookCodeJSDataModel(DS, CodeEndpoint) {
        return DS.defineResource({
            idAttribute: 'urn',
            name: 'CodebookCode',
            endpoint: CodeEndpoint.DEFAULT,
        });
    }
})();
